(() => {
  if (document.documentElement.hasAttribute('data-aleona-copy-ready')) return;
  document.documentElement.setAttribute('data-aleona-copy-ready', '');
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-tw-copy-code]');
    if (!button) return;
    const label = button.querySelector('[data-tw-copy-code-label]');
    const code = button.dataset.twCopyCode;
    if (!label || !code) return;
    const original = button.dataset.copyOriginal || label.textContent;
    button.dataset.copyOriginal = original;
    const showCopied = () => {
      window.clearTimeout(button.aleonaCopyTimer);
      label.textContent = button.dataset.twCopiedLabel || original;
      button.classList.add('is-copied');
      button.aleonaCopyTimer = window.setTimeout(() => {
        if (!button.isConnected) return;
        label.textContent = original;
        button.classList.remove('is-copied');
      }, 2000);
    };
    const fallback = () => {
      const field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.cssText = 'position:fixed;inset:0;width:1px;height:1px;opacity:0;pointer-events:none';
      document.body.append(field);
      field.select();
      let copied = false;
      try { copied = document.execCommand('copy'); } catch { /* Visible code remains available. */ }
      field.remove();
      button.focus({ preventScroll: true });
      if (copied) showCopied();
    };
    if (navigator.clipboard?.writeText) navigator.clipboard.writeText(code).then(showCopied, fallback);
    else fallback();
  });
})();

